import { useEffect, useRef, useState } from 'react';

import { VoiceMeetingCaptions } from './VoiceMeetingCaptions';

import { useAppDispatch, useAppSelector } from 'features/app/hooks';
import {
  useCaptionDisplayConfig,
  useCaptionTurns,
} from 'features/call/call-captions/hooks';
import {
  selectCallCaptionLines,
  selectCaptionTrimOffsets,
  selectResolvedCaptionLines,
} from 'features/call/call-captions/store';

interface VoiceMeetingCaptionsContainerProps {
  holdRegionOpen?: boolean;
  onPrunedToEmpty?: () => void;
}

export const VoiceMeetingCaptionsContainer = ({
  holdRegionOpen = false,
  onPrunedToEmpty,
}: VoiceMeetingCaptionsContainerProps) => {
  const dispatch = useAppDispatch();
  const visibleCaptions = useAppSelector(selectCallCaptionLines);
  const resolvedCaptionLines = useAppSelector(selectResolvedCaptionLines);
  const captionDisplayConfig = useCaptionDisplayConfig();
  const captionLinesRef = useRef<HTMLDivElement | null>(null);
  const captionTextRefs = useRef<Record<string, HTMLElement | null>>({});
  const [resizeTick, setResizeTick] = useState(0);
  const captionsEnabled = captionDisplayConfig.enabled;
  const renderedCaptions = useCaptionTurns();
  const trimOffsets = useAppSelector(selectCaptionTrimOffsets);

  useEffect(() => {
    const handleResize = () => {
      setResizeTick((previousTick) => previousTick + 1);
    };

    globalThis.addEventListener('resize', handleResize);
    globalThis.visualViewport?.addEventListener('resize', handleResize);

    return () => {
      globalThis.removeEventListener('resize', handleResize);
      globalThis.visualViewport?.removeEventListener('resize', handleResize);
    };
  }, []);

  if (!captionsEnabled || (!visibleCaptions.length && !holdRegionOpen)) {
    return null;
  }

  return (
    <VoiceMeetingCaptions
      turns={renderedCaptions}
      captionLinesRef={captionLinesRef}
      captionTextRefs={captionTextRefs}
      dispatch={dispatch}
      visibleCaptions={resolvedCaptionLines}
      trimOffsets={trimOffsets}
      captionsEnabled={captionsEnabled}
      resizeTick={resizeTick}
      onPrunedToEmpty={onPrunedToEmpty}
    />
  );
};
